(() => {
  'use strict';

  const getTomorrowInSydney = () => {
    const parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Sydney',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }).formatToParts(new Date());

    const values = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    const tomorrow = new Date(Date.UTC(values.year, values.month - 1, values.day + 1));

    const tomorrowParts = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'UTC',
      weekday: 'short',
      day: 'numeric',
      month: 'numeric'
    }).formatToParts(tomorrow);
    const tomorrowValues = {};
    tomorrowParts.forEach((part) => {
      if (part.type !== 'literal') tomorrowValues[part.type] = part.value;
    });
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return `${tomorrowValues.weekday}, ${tomorrowValues.day} ${monthNames[Number(tomorrowValues.month) - 1]}`;
  };

  if (!customElements.get('nuve-product-status')) {
    customElements.define('nuve-product-status', class extends HTMLElement {
      connectedCallback() {
        const date = this.querySelector('[data-nuve-dispatch-date]');
        if (!date) return;

        try {
          date.textContent = getTomorrowInSydney();
        } catch (error) {
          date.textContent = 'tomorrow';
        }
      }
    });
  }

  if (!customElements.get('nuve-review-slider')) {
    customElements.define('nuve-review-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nuve-review-track]');
        this.cards = Array.from(this.querySelectorAll('[data-nuve-review-card]'));
        this.previous = this.querySelector('[data-nuve-review-previous]');
        this.next = this.querySelector('[data-nuve-review-next]');
        this.dots = Array.from(this.querySelectorAll('[data-nuve-review-dot]'));

        if (!this.track || this.cards.length < 2) return;

        this.activeIndex = 0;
        this.onScroll = this.updateFromScroll.bind(this);
        this.onPrevious = () => this.goTo(this.activeIndex - 1);
        this.onNext = () => this.goTo(this.activeIndex + 1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.previous?.addEventListener('click', this.onPrevious);
        this.next?.addEventListener('click', this.onNext);
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index));
        });

        this.updateControls();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        const card = this.cards[nextIndex];
        if (!card) return;

        this.track.scrollTo({
          left: card.offsetLeft - this.track.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        this.activeIndex = nextIndex;
        this.updateControls();
      }

      updateFromScroll() {
        window.cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = window.requestAnimationFrame(() => {
          const trackLeft = this.track.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Infinity;

          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          this.activeIndex = closestIndex;
          this.updateControls();
        });
      }

      updateControls() {
        if (this.previous) this.previous.disabled = this.activeIndex === 0;
        if (this.next) this.next.disabled = this.activeIndex === this.cards.length - 1;
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.activeIndex ? 'true' : 'false');
        });
      }
    });
  }
})();
